import React, { createContext, useContext, useState, useCallback } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '../components/Snackbar';

const SnackbarContext = createContext(null);

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }
  return context;
};

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    variant: 'success',
  });

  const showSnackbar = useCallback(({ message, variant = 'success' }) => {
    setSnackbar({
      open: true,
      message,
      variant,
    });
  }, []);

  const hideSnackbar = useCallback(() => {
    setSnackbar((prev) => ({
      ...prev,
      open: false,
    }));
  }, []);

  return (
    <SnackbarContext.Provider value={{ showSnackbar, hideSnackbar }}>
      {children}
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={hideSnackbar}
      >
        <SnackbarContent
          variant={snackbar.variant}
          open={snackbar.open}
          onClose={hideSnackbar}
          message={snackbar.message}
        />
      </Snackbar>
    </SnackbarContext.Provider>
  );
};
